import gql from "graphql-tag";

export const GET_ANALYTICS_DATA = gql`
  query GetAnalyticsData($type: String) {
    me {
      id
    }
    analyticsData(type: $type) {
      totalPlays
      totalDownloads
      totalEarnings
      monthlyPlays
      monthlyDownloads
      monthlyEarnings
      totalArtists
      totalAlbums
      totalSongs
      topTracks {
        name
        plays
        downloads
      }
      recentActivity {
        type
        title
        description
        time
      }
    }
  }
`;

export interface AnalyticsData {
  totalPlays: number;
  totalDownloads: number;
  totalEarnings: number;
  monthlyPlays: number;
  monthlyDownloads: number;
  monthlyEarnings: number;
  totalArtists: number;
  totalAlbums: number;
  totalSongs: number;
  topTracks: Array<{
    name: string;
    plays: number;
    downloads: number;
  }>;
  recentActivity: Array<{
    type: string;
    title: string;
    description: string;
    time: string;
  }>;
}

export interface GetAnalyticsDataResponse {
  me: {
    id: string;
  };
  analyticsData: {
    totalPlays: number;
    totalDownloads: number;
    totalEarnings: number;
    monthlyPlays: number;
    monthlyDownloads: number;
    monthlyEarnings: number;
    totalArtists: number;
    totalAlbums: number;
    totalSongs: number;
    topTracks: Array<{
      name: string;
      plays: number;
      downloads: number;
    }>;
    recentActivity: Array<{
      type: string;
      track: string;
      time: string;
    }>;
  };
}

export default GET_ANALYTICS_DATA;
